import React from 'react';
import { DividerElement as DividerType } from '../../types/element.types';

interface DividerElementProps {
  element: DividerType;
}

/**
 * Divider Element Renderer
 * Horizontal line separator
 */
const DividerElement: React.FC<DividerElementProps> = ({ element }) => {
  const { thickness, color, style: dividerStyle } = element.settings || {};

  return (
    <hr
      className="divider-element"
      style={{
        ...element.styles,
        border: 'none',
        borderTop: `${thickness || '1px'} ${dividerStyle || 'solid'} ${color || '#e5e7eb'}`,
      } as React.CSSProperties}
    />
  );
};

export default DividerElement;

